import type {
  ProductTemplateCreateRequestType,
  ProductTemplateCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductTemplateCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductTemplateCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "product-template",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<ProductTemplateCreateResponseType>(response).data,
      ),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.ProductTemplate],
      }),
  });
};
